export var UploadTypesEnum;
(function (UploadTypesEnum) {
    UploadTypesEnum["BRANDING"] = "BRANDING";
    UploadTypesEnum["USER_PROFILE"] = "USER_PROFILE";
})(UploadTypesEnum || (UploadTypesEnum = {}));
//# sourceMappingURL=storage.js.map